import { ref } from 'vue';

/**
 * Module-level auth error surfaced as a global dialog (rendered once in App.vue).
 * Used so a blocking auth error (e.g. a Google sign-up rejected because the email
 * already has an email+password account) is shown even across the OAuth redirect —
 * the web callback sets it, then navigates to the login page where the dialog appears.
 */
const authErrorMessage = ref<string | null>(null);

export const useAuthError = () => {
  const setAuthError = (message: string) => { authErrorMessage.value = message || null; };
  const clearAuthError = () => { authErrorMessage.value = null; };
  return { authErrorMessage, setAuthError, clearAuthError };
};
